








import { OElement } from '../element';
import Vue from 'vue';

export default Vue.extend({
  name: 'OFieldset',
  components: { OElement },
});
